import { useUser } from 'contexts/UserContext'
import { menuItems } from 'data/menuItems'
import PropTypes from 'prop-types'
import { useLocation } from 'wouter'
import MenuItems from './MenuItems'

export default function Menu({ isSidebarOpen }) {
  // Hook para gestionar el usuario actual
  const { user } = useUser()

  // Wouter - useLocation() permite cambiar de pantalla
  const [location] = useLocation()

  return (
    menuItems &&
    menuItems.map((item, index) => {
      return (
        <MenuItems
          key={index}
          item={item}
          user={user}
          location={location}
          isSidebarOpen={isSidebarOpen}
        />
      )
    })
  )
}

// Define los tipos de las props que recibe el componente actual
Menu.propTypes = {
  isSidebarOpen: PropTypes.bool
}
